<template>
    <div class="default-input input-date" ref="calendarEl" data-vue-handed :date-calendar-min="min" :date-calendar-max="max">
        <div class="default-input__body" data-sticky-label>
            <input class="default-input__input input-date__input" type="text"
                   readonly :name="name" :placeholder="placeholder" :id="id" :disabled="disabled" v-model="value">
            <label class="default-input__label">{{ label || placeholder }}</label>
        </div>
        <div class="calendar-popup visually-hidden"></div>
    </div>
</template>

<script>
export default {
    name: "InputDate",
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        min: {
            type: String,
            default: null
        },
        max: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            selectedDates: null
        }
    },
    mounted() {
        this.initCalendar();
    },
    computed: {
        value: {
            get() {
                let date = this.modelValue;

                if (this.modelValue) {
                  date = new Date(this.modelValue);
                  date = ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth()+1)).slice(-2) + '.' + date.getFullYear();
                }

                return date;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    },
    methods: {
        initCalendar() {
            const calendarEl = this.$refs.calendarEl;

            if (!window.initCustomCalendar || !calendarEl) return;

            const calendarPopupDate = window.initCustomCalendar(calendarEl);

            const self = this

            calendarPopupDate.actions.clickDay = (e, dates) => {
                if (dates.length) {
                    e.target.closest('.calendar-popup')?.classList.add('visually-hidden');
                    self.value = dates[0];
                } else {
                    self.value = '';
                }

            }

            calendarPopupDate.update();

        },
    }
}
</script>

<style scoped>

</style>